import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { PageHero, Container } from "../components/Section";
import { api } from "../lib/api";
import { ArrowRight } from "lucide-react";

export default function Ministries() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/ministries").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="ministries-page">
      <PageHero
        overline="Ministries Overview"
        title={<>Many Members. <em className="text-gold-light italic font-light">One Body.</em></>}
        kicker="Every ministry exists to glorify God, edify the church, and reach the world. Discover where your gifts can serve."
      />

      <Container className="py-20">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/5">
          {items.map((m, i) => (
            <motion.div
              key={m.id}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
              className="bg-wine-950 p-10 hover:bg-wine-900 transition-colors group min-h-[280px] flex flex-col"
              data-testid={`ministry-card-${m.slug}`}
            >
              <div className="text-xs uppercase tracking-widest text-gold mb-4">Ministry · {String(i + 1).padStart(2, "0")}</div>
              <h3 className="font-serif text-3xl font-black mb-4 group-hover:text-gold-light transition-colors">{m.name}</h3>
              <p className="text-white/65 leading-relaxed text-sm flex-1">{m.description}</p>
              <div className="mt-6 pt-6 border-t border-white/5 flex items-center justify-between">
                <div className="text-xs text-white/40">Lead: <span className="text-white/70">{m.lead}</span></div>
                <ArrowRight className="h-4 w-4 text-gold/60 group-hover:text-gold group-hover:translate-x-1 transition-all" />
              </div>
            </motion.div>
          ))}
        </div>
      </Container>
    </div>
  );
}
